export default __webpack_public_path__ + "static/media/ac_elbe.9e9a84d4.bmp";